import QGTRADER_EXT_1 from "./QGTRADER_EXT_1";
export default {
  QGTRADER_EXT_1,
};
